import { render, staticRenderFns } from "./SendForSelection.vue?vue&type=template&id=cab0771c"
import script from "./SendForSelection.vue?vue&type=script&lang=js"
export * from "./SendForSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports